export default __webpack_public_path__ + "static/media/element_39.5450948c.webp";